import React from "react";
import "./breadcrumb.scss";
import AngleLeft from "./icons/angleLeft.svg";

const BreadCrumb = ({ list }) => {
  return (
    <div className="breadcrumb-wrapper">
      <ul className="breadcrumb-list">
        {list &&
          list.map((item, index) => (
            <li className={index === 0 ? 'mb-2 pl-0' : ''}>
              {index === 0 && <img src={AngleLeft} alt="" />}
              {(item.href && <a href={item.href}>{item.label}</a>) || (
                <span>{item.label}</span>
              )}
              {index != list.length -1 && <span class="bar pl-2">|</span>}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default BreadCrumb;
